import type { IChosenItem } from "../../../../app/@types/chosenItems";
import { MarketingChannelsDistributionCompare } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistributionCompare";
import { MarketingChannelsDistributionService } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistributionService";
import { MarketingChannelsDistributionSingle } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistributionSingle";
import type { EMarketingChannelsType } from "app/components/React/MarketingChannelsDistribution/types";
import React from "react";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { NoData } from "./NoData";
import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

interface IMarketingChannelsDistributionProps {
    chosenItems: IChosenItem[];
    marketingChannelsType: EMarketingChannelsType;
}

const validateHandler = (chosenItems, marketingChannelsDistributionData) => {
    if (!marketingChannelsDistributionData) {
        return false;
    }
    const sortedChosenItems = chosenItems.map(({ name }) => name).sort();
    const sortedMarketingChannelsDistributionData = Object.keys(marketingChannelsDistributionData).sort();
    const allItemsHaveData = Object.values(marketingChannelsDistributionData).reduce(
        (result, current) => result && Boolean(current),
        true,
    );
    return sortedChosenItems.join() === sortedMarketingChannelsDistributionData.join() && allItemsHaveData;
};

const MarketingChannelsDistributionInner: React.FunctionComponent<IMarketingChannelsDistributionProps> = (props) => {
    const { chosenItems, marketingChannelsType } = props;
    const { params } = useCurrentStateAndParams();
    const isCompare = chosenItems.length > 1;
    const [isLoading, setIsLoading] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    const [marketingChannelsDistributionData, setMarketingChannelsDistributionData] = React.useState(undefined);
    const bootstrap = async () => {
        !isLoading && setIsLoading(true);
        const marketingChannelsDistributionService = new MarketingChannelsDistributionService(params);
        try {
            const data = await marketingChannelsDistributionService.getData();
            setMarketingChannelsDistributionData(data.Data);
            isError && setIsError(!isError);
        } catch (e) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };
    React.useEffect(() => {
        bootstrap();
    }, [params.key]);
    const marketingChannelsDistributionCommonProps = {
        marketingChannelsDistributionData,
        marketingChannelsType,
        chosenItems,
    };
    if (!validateHandler(chosenItems, marketingChannelsDistributionData)) {
        !isError && setIsError(!isError);
    }
    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                width={"50%"}
                height={26}
            />
        );
    }
    if (isError) {
        return <NoData {...marketingChannelsDistributionCommonProps} />;
    }

    return (
        <>
            {isCompare ? (
                <MarketingChannelsDistributionCompare {...marketingChannelsDistributionCommonProps} />
            ) : (
                <MarketingChannelsDistributionSingle {...marketingChannelsDistributionCommonProps} />
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    const { routing } = state;
    const { chosenItems } = routing;
    return {
        chosenItems,
    };
};

export const MarketingChannelsDistribution = connect(mapStateToProps)(MarketingChannelsDistributionInner);
